/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "services/api";
import { User } from "models/user";
import { Button } from "components/Button";
import {
  PlusIcon,
} from "lucide-react";
import { useGroupStore } from "stores/useGroup";
import { useUser } from "stores/useUser";
import { useTranslation } from "react-i18next";
import { UserList } from "./UserList";
import { MainLayoutGroupPage } from "../mainLayout";
import { UserDialog } from "../UserDialog";

export function GroupUserPage() {
  const { t } = useTranslation()
  const group = useGroupStore((state) => state.group);
  const reload = useGroupStore((state) => state.reload);
  const can = useUser((state) => state.can);
  const loggedUser = useUser((state) => state.user);
  const [userDialog, setUserDialog] = useState(false);
  const [editUser, setEditUser] = useState<User | null>(null);
  const navigate = useNavigate();

  function handleUser()
  {
      if (loggedUser)
      {
          if (can(["admin", "manager", "coordinator"]) === false)
          {
              if (!loggedUser.group) 
              {
                  navigate(`/`);
                  return;
              }
              navigate(`/grupos/${loggedUser?.group.id}`);
              return;
          }
      }
  }
  useEffect(handleUser, [loggedUser]);

  function handleSubmitUser() {
    setUserDialog(false);
    setEditUser(null);
    reload();
  }

  function handleEditUser(user: User) {
    setEditUser(user);
    setUserDialog(true);
  }

  function handleNewUser() {
    setEditUser(null);
    setUserDialog(true);
  }

  function handleRemoveUser(user: User) {
    if (
      confirm(
        t("users.deleteDialog").replace("%name%", user.name)
      )
    ) {
      api.delete(`/users/${user.id}`).then(reload);
    }
  }
  if (group === null) return <></>;
  return (
    <MainLayoutGroupPage
      subtitle={t("users.description")}
      actionButton={
        <Button onClick={handleNewUser}>
          <PlusIcon size={16} />
          {t("users.new")}
        </Button>
      }
    >
      <table className="m-0">
        <tbody>
          {group.users.map((user) => <UserList user={user} onEdit={handleEditUser} onRemove={handleRemoveUser} />)}
        </tbody>
      </table>
      <UserDialog
        user={editUser}
        open={userDialog === true}
        setOpen={setUserDialog}
        group={group}
        onSubmit={handleSubmitUser}
      />
    </MainLayoutGroupPage>
  );
}
